import { useEffect } from "react";
import { useLocation } from "react-router";

const useAnchorFocusOnMount = (anchor, anchorRef) => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash === `#${anchor}` && anchorRef.current) {
      requestAnimationFrame(() => {
        anchorRef.current.scrollIntoView();
        anchorRef.current.focus();
      });
    }
  }, [anchor, anchorRef, location]);
};

export default useAnchorFocusOnMount;
